export default __webpack_public_path__ + "ea042183cefad97617bf0c01fc0cedd0.png";